import React, { FC } from 'react';
import { NotificationBanner } from 'src/components/widgets/notificationBanner';
import { Link } from 'src/components/widgets/buttons';
import { T } from 'src/shared/helpers';

// The AI Credits and Billing help article, the same link of the other AI credits notices (AiCreditsNotice).
const AI_CREDITS_BILLING_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/31154048227740-AI-Credits-and-Billing';

interface DiscoveryAiActivationBannerProps {
    /** Grants the one-time free trial pack (auto-refill off); the parent re-resolves + opens any pending tool. */
    onActivate: () => void;
    /** True while the grant mutation is in flight — disables the button to prevent a double activation. */
    isActivating: boolean;
}

/**
 * Discovery-mode "This tool is billed via credits" banner (CASE 1: the seller has never activated the free
 * trial nor bought credits). Shown persistently at the top of the AI Creative Tools panel while the seller is
 * un-activated — the same copy as the original AI-rule setup pages, rendered inline (not a modal). The AI-tool
 * gate still holds: engaging a tool won't open it until the seller activates from here.
 */
const DiscoveryAiActivationBanner: FC<DiscoveryAiActivationBannerProps> = ({ onActivate, isActivating }) => (
    <NotificationBanner
        type='AI'
        variant='extended'
        content={
            <>
                <strong>{T._('This tool is billed via credits', 'Admin')}</strong>
                {'\n'}
                {T._('Each output you generate uses AI credits. You start with free credits, then usage is billed automatically.', 'Admin')}{' '}
                <Link href={AI_CREDITS_BILLING_URL} target='_blank'>
                    {T._('How AI credits work', 'Admin')}
                </Link>
                .
            </>
        }
        buttons={[
            {
                label: isActivating ? T._('Activating…', 'Admin') : T._('Activate free credits', 'Admin'),
                onClick: onActivate,
                disabled: isActivating
            }
        ]}
    />
);

export default DiscoveryAiActivationBanner;
